import { faWebcam } from '@fortawesome/pro-light-svg-icons';
import React from 'react';
import { useSelector } from '../../../redux';
import { ActiveNestedItem } from '../HeaderProvider';
import { MobileExpandableMenuItem } from './MobileExpandableMenuItem';
import { MobileLink } from './MobileLink';
import { useGenerateCamUrlWithParams } from 'src/client/helpers/urls/useGenerateCamUrlWithParams';
import { MobileCamProviderLiveGirls } from './MobileCamProviderLiveGirls';

type Props = {
  isEligible: boolean;
};

export const MobileLiveGirls = (props: Props) => {
  const { isEligible } = props;
  const config = useSelector((state) => state.app.config);
  const { cams, loaded } = useSelector((state) => state.cams);

  const isSingleCamProvider = (config?.camProviders?.length ?? 0) === 1;

  const generateCamUrlWithParams = useGenerateCamUrlWithParams({
    trackingPosition: 'mobileMenu',
    provider: config?.camProviders?.[0].provider ?? 'streamate',
  });

  if (!isEligible) {
    return null;
  }

  if (isSingleCamProvider) {
    return (
      <MobileLink
        label="Live Girls"
        href={generateCamUrlWithParams('/cams-list')}
        icon={faWebcam}
        openNewWindow={true}
      />
    );
  }

  return (
    <>
      {loaded &&
        cams &&
        cams.length > 1 &&
        cams.map((provider) => <MobileCamProviderLiveGirls key={provider.provider} provider={provider} />)}
      {config.camsList && (
        <MobileExpandableMenuItem activeNestedItem={ActiveNestedItem.LIVEGIRLS} icon={faWebcam} menuLabel="Live Girls">
          {config.camsList.map((cam) => (
            <a key={cam.name} href={cam.url} target="_blank" rel="noreferrer">
              {cam.name}
            </a>
          ))}
        </MobileExpandableMenuItem>
      )}
    </>
  );
};
